module.exports = {"510112001":"龙泉街道","510112002":"大面街道","510112003":"十陵街道","510112004":"同安街道","510112102":"洛带镇","510112104":"西河镇","510112108":"洪安镇","510112109":"柏合镇","510112110":"茶店镇","510112111":"黄土镇","510112115":"山泉镇","510112200":"万兴乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/510112.json
// module id = 2079
// module chunks = 0